<template>
  <img class="banner-image" src="../assets/toppic/图片-06.jpg"/>
  <div class="panel-div">
     <div class="title-panel-name">
        <div class="item-group-div"  v-for="(item,index) in contentusList" :key="item.id">
          <span :class="{'panel-span active':activeName == item.title,'panel-span':activeName != item.title,}" @click="changePanel(index)">{{item.title}}</span>
          <span v-if="index < contentusList.length -1">|</span>
        </div>
     </div>

    <div class="content-div" v-for="item in contentusList" :key="item.title" >
      <div class="content-item"  v-if="activeName == item.title" v-html="item.content"></div>
      </div>
    </div>
</template>

<script>
import{ contentus } from "@/api/AboutMe";

export default {
  name: 'ContactUs',

  props: {
    msg: String
  },
  data(){
    return {
      contentusList:[],
      activeName:null
    }
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    var languageStr = localStorage.getItem("website-language");

    if(!languageStr){
      var intervalIndex = setInterval(() =>{
        var languageStr = localStorage.getItem("website-language");
        if(languageStr){
          clearInterval(intervalIndex);
          this.language = JSON.parse(languageStr);
          this.initData();
        }
      },100);
    }else{
      this.language = JSON.parse(languageStr);
      this.initData();
    }
  },
  methods: {
    initData() {
      contentus({id:this.language.id}).then(res => {
        console.log(res);
        this.contentusList = res.data;
        this.activeName = this.contentusList[0].title;
      });
    },
    changePanel(index) {
      this.activeName = this.contentusList[index].title;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.panel-div{
  padding:20px 35px;
  text-align: left;
}
.panel-div .title-panel-name{
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width:auto;
  overflow-x: scroll;
  padding:0px 10px;
  scrollbar-width: thin; /* auto | thin | none */
  scrollbar-color: #4CAF50 #f1f1f1; /* 滑块颜色 轨道颜色 */
  margin:20px 0px;
  margin-bottom: 60px;
}

.title-panel-name::-webkit-scrollbar {
  height:2px;
}

.title-panel-name::-webkit-scrollbar-thumb {
  background: #EFEFEF;
  border-radius: 3px;
}

.content-item{
  text-align: left;
}

.content-item>>> img{
  display: block;
  margin: 10px auto;
  width:100%;
}

@media (max-width: 720px) {

  .panel-div{
    padding:20px 10px;
  }
  .content-item>>> img{
    display: block;
    margin: 10px auto;
    width:100%;
  }
}


.panel-div .title-panel-name .panel-span{
  display: inline-block;
  background-color: #EFEFEF;
  white-space: nowrap;
  margin:6px 13px;
  padding:8px 18px;
  border-radius: 3px;
  cursor: pointer;
  font-weight: 600;
  color:#303133;
}

.item-group-div{
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
  .panel-div .title-panel-name .panel-span:hover{
    font-weight: 700;
    color:#1890ff;
    background-color:#e9f4ff;
  }
  .panel-div .title-panel-name .active{
    font-weight: 700;
    color:#1890ff;
    background-color:#e9f4ff;
  }
</style>
